import { useLanguage } from './language-context';

// Shared error / empty states for the data screens. The retry button re-runs the
// loader via useResource's `reload`. Duplicated per surface (CB-D3).
export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  const { t } = useLanguage();
  return (
    <div className="card" style={{ padding: 24, textAlign: 'center' }} role="alert">
      <p style={{ fontWeight: 600, margin: '0 0 4px' }}>{t('common.error_title')}</p>
      <p className="muted" style={{ margin: '0 0 16px' }}>
        {t('common.error_body')}
      </p>
      {onRetry && (
        <button className="btn btn--ghost" onClick={onRetry}>
          {t('action.retry')}
        </button>
      )}
    </div>
  );
}

export function EmptyState({ title, body }: { title?: string; body?: string }) {
  const { t } = useLanguage();
  return (
    <div className="card" style={{ padding: 24, textAlign: 'center' }}>
      <p style={{ fontWeight: 600, margin: '0 0 4px' }}>{title ?? t('common.empty')}</p>
      {body && (
        <p className="muted" style={{ margin: 0 }}>
          {body}
        </p>
      )}
    </div>
  );
}
